import * as PIXI from "pixi.js";
import { Container, Sprite } from "@inlet/react-pixi/animated";
import card1 from "../../assets/games/AccountMemory/tarjeta1.png";
import card2 from "../../assets/games/AccountMemory/tarjeta2.png";
import card3 from "../../assets/games/AccountMemory/tarjeta3.png";
import card4 from "../../assets/games/AccountMemory/tarjeta4.png";
import back from "../../assets/games/AccountMemory/tarjeta5.png";
import gameOk from "../../assets/games/AccountMemory/juego_edocuenta_gana.png";
import gameWrong from "../../assets/games/AccountMemory/juego_edocuenta_pierde.png";
import { useEffect, useState } from "react";
import ProgressBar from "../../baseComponents/ProgressBar";
import GameDialog from "../../baseComponents/GameContainer/components/GameDialog";

const cards = [card1, card2, card3, card4];

export default function AccountMemory({ visible, close, reset }) {
  const TIME_LIMIT = 20;

  const [currentTime, setCurrentTime] = useState(0);
  const [deck, setDeck] = useState([]);
  const [flippedCards, setFlippedCards] = useState([]);
  const [matchedCards, setMatchedCards] = useState([]);
  const [message, setMessage] = useState({ status: false, visible: false });

  // Shuffle and create pairs of cards
  useEffect(() => {
    const shuffledDeck = [...cards, ...cards]
      .sort(() => Math.random() - 0.5)
      .map((card, index) => ({ id: index, card, flipped: false }));
    setDeck(shuffledDeck);
  }, [reset]);

  const closeDialog = () => {
    if (message.status) {
      close();
    } else {
      const shuffledDeck = [...cards, ...cards]
        .sort(() => Math.random() - 0.5)
        .map((card, index) => ({ id: index, card, flipped: false }));
      setDeck(shuffledDeck);
      setMessage({ status: false, visible: false });

      reset();
    }
  };

  const handleCardClick = (id) => {
    if (flippedCards.length === 2 || matchedCards.includes(id)) return;

    const newDeck = deck.map((card) =>
      card.id === id ? { ...card, flipped: true } : card
    );
    setDeck(newDeck);

    const newFlippedCards = [...flippedCards, id];
    setFlippedCards(newFlippedCards);

    if (newFlippedCards.length === 2) {
      const [firstCard, secondCard] = newFlippedCards.map(
        (cardId) => newDeck.find((card) => card.id === cardId).card
      );

      if (firstCard === secondCard) {
        setMatchedCards((prev) => [...prev, ...newFlippedCards]);

        // Check if the correct card (card1) is matched
        if (firstCard === card1) {
          setMessage({ status: true, visible: true });
        }
      }

      setTimeout(() => {
        setDeck((prevDeck) =>
          prevDeck.map((card) =>
            newFlippedCards.includes(card.id)
              ? { ...card, flipped: matchedCards.includes(card.id) }
              : card
          )
        );
        setFlippedCards([]);
      }, 1000);
    }
  };

  const updateTime = () => {
    if (currentTime < TIME_LIMIT) {
      setTimeout(() => {
        setCurrentTime(currentTime + 1);
      }, 1000);
    } else {
      setMessage({ status: false, visible: true });
    }
  };

  useEffect(() => {
    if (visible) {
      updateTime();
    } else {
      setCurrentTime(0);
    }
  }, [currentTime, visible]);

  if (message.visible) {
    return (
      <GameDialog
        image={message.status ? gameOk : gameWrong}
        button={message.status ? "Continuar" : "Seguir buscando"}
        close={closeDialog}
        scale={message.visible ? 1 : 0}
        alpha={message.visible ? 1 : 0}
      />
    );
  }

  if (!visible) {
    return <Container alpha={0} />;
  }

  return (
    <Container
      position={[
        (window.innerWidth - 4 * 150) / 2, // Center horizontally (4 cards per row, 150px spacing)
        (window.innerHeight - 2 * 200) / 2, // Center vertically (2 rows, 200px spacing)
      ]}
      alpha={1}
    >
      <ProgressBar x={70} y={-300} value={currentTime} limit={TIME_LIMIT} />
      {deck.map(({ id, card, flipped }) => (
        <Sprite
          key={id}
          image={flipped ? card : back}
          x={(id % 4) * 170} // Horizontal position within the grid
          y={Math.floor(id / 4) * 220} // Vertical position within the grid
          width={150}
          height={200}
          interactive
          pointerdown={() => handleCardClick(id)}
        />
      ))}
    </Container>
  );
}
